import { GetApiDataWithCondition } from './fetchConfig';

export const useUser = (user) => {
  return GetApiDataWithCondition('/users', user !== null);
};

export const useUserRoles = (user) => {
  return GetApiDataWithCondition('/users/roles', user !== null);
};
